(function () {
    'use strict';

    angular
        .module('app')
        .controller('ResetPasswordController', ResetPasswordController);

    ResetPasswordController.$inject = ['$http', '$rootScope', '$scope', '$stateParams', '$state', '$location','authenticator','isTokenValid'];

    function ResetPasswordController($http, $rootScope, $scope, $stateParams, $state, $location,authenticator,isTokenValid) {
        var vm = this;
        vm.$onInit = init;
        vm.close = close;
        vm.resetPassword = resetPassword;
        vm.pattern = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9{}_=[+:;'"<,>./?!@#$%^&*()~`|\\ÅåÆæØø-]+)$/;
        vm.lostFocus = lostFocus;
        vm.resetState = resetState;
        vm.isTokenValid = isTokenValid.valid;
        vm.forgottenPassword = forgottenPassword;
        function init(){
            $rootScope.header_inverted = false;;
            $rootScope.on_dashboard = false;
            $rootScope.dark_text_header = true;
            var queryParams = $location.search();
            vm.token = queryParams['t'];
        }
        vm.password_changed = false;
        function resetPassword(){
            return $http.post('api/users/reset_password', {token: vm.token, password: md5(vm.new_password)})
                .then(function(response){
                    vm.password_changed = response.data.password_changed;
                    setTimeout(function() {
                        login();
                    }, 1000);
                })
                .catch(function(response){
                    vm.error = true;
                    if(response.data.indexOf('Invalid or expired token') >= 0){
                        vm.error_type = 'Invalid or expired token';
                    }
                })
        }
        function login() { //Login if password and email match, otherwise return error and check the login-status again
            authenticator.login($stateParams.email, vm.new_password, false)
                .then(function(response){
                    setTimeout(function() {
                        $rootScope.$emit('check_login_status');
                    }, 0);
                });
        }
        function close(){
            return $state.go('frontpage')
        }

        function lostFocus(elem){
            if(elem.$viewValue){
                elem.$lostFocus = true
            }
            else{
                elem.$lostFocus = false;
            }
        }

        function resetState(elem){
            if(!elem.$viewValue){
                elem.$lostFocus = false;
            }
        }

        function forgottenPassword()
        {
            return $http.post('/app/api/users/forgotten_password', {email: $stateParams.email})
                .then(function(response){
                    $state.go('forgotten_password', {"user_email": $stateParams.email});
                });
        }
    }
})();
